import { render, staticRenderFns } from "./StoryText.vue?vue&type=template&id=65e0c6c2&scoped=true&"
import script from "./StoryText.vue?vue&type=script&lang=js&"
export * from "./StoryText.vue?vue&type=script&lang=js&"
import style0 from "./StoryText.vue?vue&type=style&index=0&id=65e0c6c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e0c6c2",
  null
  
)

export default component.exports